import(/* webpackMode: "eager" */ "/home/claude/hadatha/hadatha/src/app/search/page.tsx");
